import Styled from 'styled-components';
import first_icon from "../../../../assets/images/icons/first_icon.svg"

const ProjectsModalView = Styled.div`
.total_container {
    display: grid;
    grid-template-columns: 75% 25%;
}
.top_div{
  background:#3E3F3E;
  border-radius: 2px;
}
.no_task_top{
  background: #DD8917;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 2px;
}
.inprogress_emp{
    background: #2987E4;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    border-radius: 2px;
    padding: 15px;
}
.second_container{
  padding: 10px 0px 0px 10px;
}
.count_inprogress{
    font-size: 35px;
    font-weight: bold;
}
.employee_p{
    font-size: 15px;
    font-weight: 600;
    margin-top: -10px !important;
}
.inprogress_tr{
  background: #3E3F3E !important;
  border-top:0px !important;
  padding: 2px;
}
.inprogress_td{
  background: #3E3F3E !important;
  color:white !important;
  width: 100%;
  padding-right: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.inprogress_table{
  height:40vh;
  overflow-y:scroll;
}
.no_task_table{
  height:10vh;
  overflow-y:scroll;
  
}
.no_task_table::-webkit-scrollbar {
  width: 10px;
  height: 8px;
  background-color: #aaa; /* or add it to the track */
}
.no_task_table::-webkit-scrollbar-thumb {
  background: #DD8917;
}
.inprogress_table::-webkit-scrollbar {
  width: 10px;
  height: 8px;
  background-color: #aaa; /* or add it to the track */
}
.inprogress_table::-webkit-scrollbar-thumb {
  background: #2987E4;
}
.center_dotted{
  border-top: 1px dashed rgb(204 204 204 / 54%);
  width: -webkit-fill-available;
}
.bck_ovr {
    min-width: fit-content;
    padding: 5px;
}
.table-view-card
{
    background-color: ${({ theme }) => theme["tableViewCard"]};
}
.card-body{
  padding:0px !important;  
}
.trackingPage{
  margin-top: -9px;
}
thead th {
  background-color: #3C80C4 !important; 
  opacity: 1 !important;
  color:green;
}
table tr:first-child {
  background: transparent linear-gradient(180deg, #3E3F3E 0%, #FFBA00 100%) 0% 0% no-repeat padding-box;
  opacity: 0.9;
}
table tr:nth-child(2) {
  background: transparent linear-gradient(180deg, #3E3F3E 0%, #68D808 100%) 0% 0% no-repeat padding-box !important;
  opacity: 0.9;

}
table tr:nth-child(3) {
  background: transparent linear-gradient(180deg, #3E3F3E 0%, #00CEFF 100%) 0% 0% no-repeat padding-box;!important;
  opacity: 0.9;
}
.user_name{
    display: flex;
    justify-content: center;
    align-items: center;
}

table tr:first-child td:last-child {
  color: #FFBA00; 
  font-weight: bold; 
}
table tr:nth-child(2) td:last-child
 {
  color: #68D808;
  font-weight: bold;
}
table tr:nth-child(3) td:last-child {
  color: #00CEFF;
  font-weight: bold;
}
.gained_points{
  color: #76BAFF;
}
.card-body > .row > div:first-child {
  margin: 0 !important;
}
.kpi_head{
  font-size:17px;
  font-weight:600;
}
table tr {
  border-top: 4px solid #292a29;
}
.btn-close {
    margin-bottom: 20px;
    margin-right: 5px;
}
.project_Table_delete_icon{
  right: 5%;
}
.project_Table_delete_btn{
  color: #FC5060;
}
.dropdown-toggle::after
{
    display:none;
}

.modal-header {
    position: relative;
}

.tr-color{
  color: ${({ theme }) => theme["themeColor"]};
}

.modal-header:after {
  background: linear-gradient(to right, #4285f4 25%, #34a853 25%, #fabb05 50%, #e94235 75%);
    position: absolute;
    content: '';
    height: 4px;
    right: 0;
    left: 0;
    bottom: 0;
}

.trackingPage .table-responsive {
    overflow: hidden;
    overflow-x: auto;
}

.trackingPage table thead th {
    font-size: 14px;
    vertical-align: middle;
    white-space: nowrap;
}

.userRoleTypePart  {
    color: ${({ theme }) => theme["body-text"]};
}

.closeicon{
  margin-top: 2px;
  color: #4EB6EE;
  float: left;
}

.block-icon{
  color: red;
}

.projectconatiner{
  background-color:${({ theme }) => theme["tableViewCard"]};;
}

.serchDropdownMenu
{
    min-width: 250px;
    padding: 10px;
    top: 5px !important;
    box-shadow: 0px 2px 11px 0 rgb(0 0 0 / 24%);
    border: none;
}
.serchDropdownMenu input
{
    font-size:13px;
}

.filter-dropdown label
{
  font-weight: 600;
  font-size: 14px;
  line-height: normal;
  margin-bottom: 5px;
}

.filter-dropdown .dropdown-menu {
  inset: 0px 45px auto auto !important;
  transform: inherit !important;
  top: 45px !important;
  right: 0 !important;
  width: 500px !important;
  position:relative;
  }
  .filter-dropdown .dropdown-menu:after {
    border: solid transparent;
    content: " ";
    border-left: 15px solid transparent;
    border-right: 0px solid transparent;
    border-bottom: 12px solid #ffffff;
    position: absolute;
    top: -6px;
    right: 15px;   
    transform: rotate(222deg);
}

.titlecancel, .titleupdate{
        padding: 4px 4px;
        color:  #9d9d9d;
        background: #f1f1f1;
        border: 2px solid #d3d3d3; 
        border-color: #d3d3d3;
        &:hover {
          background: #a6a6a6;
          color: white;
        }
    }
  .filter-dropdown .crosIcon
  {
    width: 15px;
    height: 15px;
  }
  .tracking-count {
     margin-right: 7px;
     margin-bottom : 5px;
     padding: 6px;
     border-radius: 5px;
     font-size: 13px;
     color : white;
     display: inline-block;
  }

  .tasks-tabs .nav-link.active {
    color:  #4EB6EE;
  }
  
  .tasks-tabs  .nav-link:hover {
    border-color:  #292a29;
  }

  .nav-tabs .nav-link {
    border: 0px;
  }
 
  .edit-content { 
    width: 300px;
    display: inline-flex;
    padding: 7px 20px 7px 10px;
    color: ${({ theme }) => theme["themeColor"]};
  }
  .responsive-iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .select-options{
    border-radius: 5px;
    padding: 0px 10px;
    width :210px;
    height: 30px;
  }

  select.select-options.form-select.form-select-sm{
    color: #212529;
    background-color: #fff;  
  }

  .imgRow {
    margin-top: 60px !important;
    display: inline-flex;
    flex-direction: row;
  }
  .downloadbtn{
    color: ${({ theme }) => theme["themeColor"]}; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  [data-rmiz] {
  }
  .file {
    display: inline-flex;
    flex-direction: row;
  }
  .Filecontainer {
    margin-bottom: 30px;
  }
  .filename{
    color: ${({ theme }) => theme["themeColor"]};
    font-size: 9px;
    height: 30px;
    margin-top: 5px;
    width: 120px;
     display: flex;
     align-items: center;
     justify-content: center;
     overflow: hidden;
  }
  .videoname {
    right: 105px;
  }

  .refreshicon{
    float: right;
    color: #4EB6EE;
    bottom: 9px;
  }

.nodata{
  color: ${({ theme }) => theme["themeColor"]};
  display: flex;
  align-items: center;
  justify-content: center;
}

.savechangesbtn {
  float: right;
}

.removebtn{
  right : 13px;
  bottom: 30px;
}
.deletebtn {
    bottom: 20px;
    color: #c60202;
    height: 20px;
    width: 1px;
  }
  .videodwn {
    right : 106px;
  }
  .addbtn {
    color: ${({ theme }) => theme["themeColor"]};
  }
  .downloadicon{
    color: ${({ theme }) => theme["themeColor"]};
  }
  .imgRow {
    margin-top: 60px !important;
    display: inline-flex;
    flex-direction: row;
  }
  .edit-content:hover { 
    border-radius: 2px;
    background-color: ${({ theme }) => theme["tableViewCard"]};
  }
  .edit-cross {
    font-size:10px;
    width: 20px;
    height : 20px;
    border : 1px solid #c5bfbf;
    border-radius: 5px;
    background: #f1f1f1;
    color: #998e8e;
    cursor: pointer;
    padding-top : 3px;
    margin-top:3px;
  }
  .clone-box {
    text-align: center;
  }
  .clone {
    cursor: pointer;
    width: 150px;   
    background-color: ${({ theme }) => theme["Clonebg"]};
    padding: 5px;
    border-radius: 50px;
    color: #3a3a3a;
  }
  .clone:hover {
    background-color: ${({ theme }) => theme["Cloneag"]};
    color : #3a3a3a;
  } 

  .description-edit {
    margin-left: 5px;
    background-color : #00000000 !important;
  }
  .comment-text {
    width:100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 5px;
  }
  .image-view-document{
    div{
      img{
        height: 120px;
        width: 120px;
      }
    }
  }
  .__react_modal_image__modal_container{
    top: 65px;
  }
  .__react_modal_image__modal_content{
    div{
      img{
        height: unset;
        width: unset;
      }
    }
  }
  .__react_modal_image__header{
    padding: 10px 20px 10px 50px; 
  }
  .back-icon-rounded{
    margin-right:30px;
  }
  .description-project{
      p{
        margin-bottom:0;
      }
  }
  @media (min-width: 576px) {
    .pagetitle
    {
        display:none;
    }
   }
@media (max-width: 991px) {
  .total_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    }
  .rank_badge{
      text-align:center;
    }
    
table tr:first-child td:last-child {
  color: white; 
  font-weight: unset; 
}
table tr:nth-child(2) td:last-child
 {
  color: white;
  font-weight: unset;
}
table tr:nth-child(3) td:last-child {
  color: white;
  font-weight: unset;
}
 
  }
@media (min-width: 992px) {
    .trackingPage table tbody tr td .mobHead {
        display: none
    }
    .fileinput {
      width: 700px !important;
     }
     .fileuploadcontainer{
       display: flex;
       align-items: center;
       justify-content: center;
     }
   
}

@media (max-width: 1350px) {
    .trackingPage table tbody tr td {
    }
}


@media (max-width: 1199px) {
    .trackingPage table tbody tr td {
    }

    .addTrack {
        padding-left: 0;
    }

    .addTrack .btn {
        padding: 8px 10px;
        font-size: 13px;
    }

}

@media (max-width: 991px) {
  .addTrack {
    padding-left: 15px;
    margin-top: 10px;
  }
  .addTrack .add-new-text {
  }
  .trackingPage table tbody tr td {
  }
  .trackingPage table thead th {
    display: none;
  }
  .trackingPage table tbody tr td {
    white-space: break-spaces;
    padding: 10px 15px !important;
    width: auto !important;
    display: block;
  }

  .taskviewtable table tbody tr td{
    white-space: break-spaces;
    padding: 10px 15px !important;
    width: auto !important;
    display: block;
  }

  .trackingPage table tbody,
  .trackingPage table td,
  .trackingPage table tr {
  }
  .trackingPage table tr {}
  .trackingPage table.table-striped>tbody>tr:nth-of-type(odd)>* {
  }
  .trackingPage table tbody tr td.actionBtns {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
}

@media (max-width:767px)
{
  .filter-dropdown .dropdown-menu {
    width: 300px !important;
  }
}

@media (max-width: 612px) {
  .select-options{
    width: 150px;
  }

  .edit-content{
    width: 180px;
    word-break: break-all;
  }
}
      
@media (max-width:575px){
  .filter-dropdown .dropdown-menu {
    right: -150px !important;
  }
  .filter-dropdown .dropdown-menu:after {
    right: 50%;
    margin-right: 15px;
  }
  .pagetitle{
    color: ${({ theme }) => theme["themeColor"]};
  }
  .Filecontainer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (max-width: 387px) {

  .select-options{
    width: 100px;
  }

  .edit-content{
    width: 180px;
    word-break: break-all;
  }
}

@media (min-width: 1220px) { 

 .projectconatiner{
   padding : 5px 110px  5px 110px ! important;
 }
 .title{
   padding : 5px 5px  5px 90px ! important;
 }
 .back-icon-rounded{
    margin-right:100px;
  }
}
@media (max-width: 1220px) and (min-width: 992px) {
.edit-content{
 width: 230px;
}
trackingviewtbody{
 margin-left: 50px;
}
}

`;
export default ProjectsModalView;

